import { ShipmentDetailsRequestModel } from "api/lokiRequestModels/shipments/ShipmentDetailsRequestModel";
import { LynxTable } from "components/LynxTable/LynxTable";
import { dateEndFormatting, dateStartFormatting } from "helpers/dateFormatting";
import { observer } from "mobx-react";
import { useStore } from "store/StoreConfigs";
import { globalViewShipmentsTableColumns } from "./GlobalViewShipmentsTableColumns";

export const GlobalViewShipmentsTableWrapper = observer(function TableWrapper() {
    const { globalViewStore, filtersStore, identityStore } = useStore();

    const onSortChange = (id: string, sortDirection: "ASC" | "DESC") => {
        globalViewStore.setShipmentSortProperty(id);
        globalViewStore.setShipmentDirection(sortDirection);
    };

    const onPageChange = (direction: "back" | "forward") => {
        if (direction === "back") {
            globalViewStore.moveToPreviousShipmentPage();
        } else {
            const request: ShipmentDetailsRequestModel = {
                startTime: dateStartFormatting(filtersStore.startDate),
                endTime: dateEndFormatting(filtersStore.endDate),
                customerId: identityStore.currentCustomerId,
                laneId: "",
                lsp: filtersStore.selectedLogisticsServiceProviders.join(",") || undefined,
                productType: filtersStore.selectedProductTypes.join(",") || undefined,
                riskLevel: filtersStore.selectRiskLevels.join(",") || undefined,
                transportationModes: filtersStore.selectedModesOfTransportation.join(",") || undefined,
                packagingType: filtersStore.selectedPackagingTypes.join(",") || undefined,
                nextToken: globalViewStore.shipmentNextToken,
                sort: globalViewStore.shipmentSort,
                direction: globalViewStore.shipmentDirection,
            };
            globalViewStore.moveToNextShipmentPage(request);
        }
    };

    return (
        <LynxTable
            columns={globalViewShipmentsTableColumns}
            rows={
                globalViewStore.shipmentPages.length === 0
                    ? []
                    : globalViewStore.shipmentPages[globalViewStore.currentShipmentPage - 1]
            }
            rowKey="shipmentId"
            page={globalViewStore.currentShipmentPage}
            isLastPage={globalViewStore.isLastShipmentPage}
            onPageChange={onPageChange}
            sortedBy={globalViewStore.shipmentSort}
            sortDirection={globalViewStore.shipmentDirection}
            onSortChange={onSortChange}
            isLoading={globalViewStore.loadingShipments}
        />
    );
});
